module.exports = __webpack_public_path__ + "img/arrow_down.b3798b7d.svg";